namespace TabAurous.OMS {
    export interface ProductSequenceForm {
        ProductId: Serenity.StringEditor;
        DepartmentId: Serenity.IntegerEditor;
        ProcessId: Serenity.IntegerEditor;
        DeptName: Serenity.StringEditor;
        ProcessName: Serenity.StringEditor;
        StdLoss: Serenity.DecimalEditor;
        MaxLoss: Serenity.DecimalEditor;
        Duration: Serenity.IntegerEditor;
        Complexity: Serenity.IntegerEditor;
        Priority: Serenity.IntegerEditor;
    }

    export class ProductSequenceForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.ProductSequence';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductSequenceForm.init)  {
                ProductSequenceForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(ProductSequenceForm, [
                    'ProductId', w0,
                    'DepartmentId', w1,
                    'ProcessId', w1,
                    'DeptName', w0,
                    'ProcessName', w0,
                    'StdLoss', w2,
                    'MaxLoss', w2,
                    'Duration', w1,
                    'Complexity', w1,
                    'Priority', w1
                ]);
            }
        }
    }
}
